<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M0 12C0 5.37689 5.37689 0 12 0C12.0113 0 12.0225 0.000233859 12.0337 0.000696888C12.045 0.000285306 12.0564 0.000108829 12.0678 0.000172264C18.6598 0.0367746 24 5.39949 24 12C24 18.6231 18.6231 24 12 24C5.37689 24 0 18.6231 0 12ZM12.0297 1.59946C12.0198 1.59982 12.0099 1.6 12 1.6C6.26055 1.6 1.6 6.26055 1.6 12C1.6 17.7395 6.26055 22.4 12 22.4C17.7395 22.4 22.4 17.7395 22.4 12C22.4 6.28019 17.7712 1.63187 12.0589 1.60015C12.0491 1.60009 12.0394 1.59986 12.0297 1.59946Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M18.1474 7.55607C18.5053 7.89274 18.5226 8.45585 18.186 8.81382L10.1434 17.3654L5.6083 12.2249C5.2832 11.8564 5.31838 11.2941 5.68688 10.969C6.05538 10.6439 6.61766 10.6791 6.94277 11.0476L10.1855 14.7231L16.8896 7.59465C17.2263 7.23668 17.7894 7.21941 18.1474 7.55607Z" :fill="fill" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'CheckCircle',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
